// =============================================================================
// MAIN APP COMPONENT
// =============================================================================

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { HomePage } from '@/pages/HomePage';
import { AboutPage } from '@/pages/AboutPage';
import { ProjectPage } from '@/pages/ProjectPage';
import { PortfolioPage } from '@/pages/PortfolioPage';
import { ServicesPage } from '@/pages/ServicesPage';
import { CoachingPage } from '@/pages/CoachingPage';
import { ContactPage } from '@/pages/ContactPage';
import { TermsPage } from '@/pages/TermsPage';
import { PrivacyPage } from '@/pages/PrivacyPage';
import { PaymentPage } from '@/pages/PaymentPage';
import { PaymentSuccessPage } from '@/pages/PaymentSuccessPage';
import { UnsubscribePage } from '@/pages/UnsubscribePage';
import { NotFoundPage } from '@/pages/NotFoundPage';
import { ToastProvider } from '@/contexts/ToastContext';
import { ToastPortal, BackToTop } from '@/components/ui';
import { NotFoundHandler } from '@/components/NotFoundHandler';
import '@/styles/main.scss';

function App() {
  return (
    <HelmetProvider>
      <ToastProvider>
        <Router
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
          }}
        >
        <NotFoundHandler>
          <div className="app">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/portfolio" element={<PortfolioPage />} />
              <Route path="/portfolio/:projectSlug" element={<ProjectPage />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/coaching" element={<CoachingPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/payment" element={<PaymentPage />} />
              <Route path="/payment/success" element={<PaymentSuccessPage />} />
              <Route path="/unsubscribe" element={<UnsubscribePage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </div>
        </NotFoundHandler>
        <ToastPortal />
        <BackToTop />
      </Router>
      </ToastProvider>
    </HelmetProvider>
  );
}

export default App;
